@if (!importing) {
<div id="import-solution-form">
  @if (isError) {
  <div class="ot-message ot-message--is-error">
    <div class="ot-message__banner">
      <p class="ot-pl-1" id="otsc-import-error-msg">
        {{importError}}
      </p>
    </div>
  </div>
  }
  <div class="ot-panel">
    <form [formGroup]="objectForm" [ngStyle]="{'height': height}" name="otsc-solution-environment-form">
      <div class="ot-panel__body" [ngStyle]="{'height': isError ? 'calc(100vh - 212px)' : height}">
        <div title="Import solution" class="otsc-settings-label" i18n-title>
          <h1 id="import-solution-title" il8n>Import solution</h1>
        </div>
        <ng-scrollbar>
          <div class="ot-mb-1 ot-mt-1 ot-ml-1 ot-mr-1">
            <div class="ot-row">
              <div class="ot-row__column ot-mr-1">
                <div class="ot-form-control"
                  [ngClass]="{'ot-form-control--is-invalid' : nameCtrl.touched && nameCtrl.invalid}">
                  <label for="name" class="ot-form-control__label">
                    @if (!nameCtrl.disabled) {
                    <span class="ot-form-control--is-required">*</span>
                    }
                    <span i18n>Name</span>
                  </label>
                  <input id="import-solution-name" name="name" formControlName="nameCtrl" placeholder="Enter name"
                    type="text" class="ot-input" maxlength="100">
                  @if (nameCtrl.invalid && (nameCtrl.dirty || nameCtrl.touched)) {
                  @if (nameCtrl.errors?.required) {
                  <p id="nameErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Name cannot be empty.
                  </p>
                  }
                  @if (nameCtrl.errors?.exists) {
                  <p id="existsErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Name already exists.
                  </p>
                  }
                  }
                </div>
              </div>
            </div>
            <div class="ot-row">
              <div class="ot-row__column ot-mr-1">
                <div class="ot-form-control"
                  [ngClass]="{'ot-form-control--is-invalid' : descriptionCtrl.touched && descriptionCtrl.invalid}">
                  <label for="description" class="ot-form-control__label">
                    <span i18n>Description</span>
                  </label>
                  <textarea id="import-solution-description" name="description" formControlName="descriptionCtrl"
                    placeholder="Enter description" class="ot-textarea" maxlength="100"></textarea>
                </div>
              </div>
            </div>
            <div class="ot-form-control">
              <label for="import-tabs" class="ot-form-control__label">
                <span i18n>Details</span>
              </label>
            </div>
            <app-tabs [identifier]="'import-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="importTabs"
              [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"></app-tabs>
            @if (activeTab == ImportTab.ENVIRONMENTS) {
            <div id="import-environments">
              @for (env of this.solutionInfo.solution.environments; track env) {
              <div name="env-row" class="ot-row env-row" style="margin-bottom: 0px;">
                @if (env.nameCtrl !== undefined) {
                <div class="ot-row__column">
                  <div class="ot-form-control" style="margin-bottom: 4px;"
                    [ngClass]="{'ot-form-control--is-invalid' :env.nameCtrl.touched && env.nameCtrl.invalid}">
                    <label [for]="env.nameCtrlName" class="ot-form-control__label">
                      <span i18n>Name</span>
                    </label>
                    <input [id]="env.nameCtrlName" name="name" [formControlName]="env.nameCtrlName" i18n-placeholder
                      placeholder="Enter name" type="text" class="ot-input" maxlength="100" (keyup)="changeName(env)">
                    @if (env.nameCtrl.invalid && (env.nameCtrl.dirty || env.nameCtrl.touched)) {
                    @if (env.nameCtrl.errors?.required) {
                    <p class="ot-form-control__error-text" i18n autocomplete="off">
                      Name cannot be empty.
                    </p>
                    }
                    @if (env.nameCtrl.errors?.exists) {
                    <p class="ot-form-control__error-text" i18n autocomplete="off">
                      Name already exists.
                    </p>
                    }
                    }
                  </div>
                </div>
                }
                @if (env.descCtrl !== undefined) {
                <div class="ot-row__column ot-row__column--is-offset-10">
                  <div class="ot-form-control"
                    [ngClass]="{'ot-form-control--is-invalid' : env.descCtrl.touched && env.descCtrl.invalid}">
                    <label [for]="env.descCtrlName" class="ot-form-control__label">
                      <span i18n>Description</span>
                    </label>
                    <input i18n-tite title="Description" [id]="env.descCtrlName" name="description"
                      [formControlName]="env.descCtrlName" type="text" class="ot-input" maxlength="100">
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
            @if (activeTab == ImportTab.PENDING_SYSTEMS) {
            <div>
              <app-datatable [identifier]="'import-systems-table'" [cols]="systemCols" [rows]="systemRows"
                [isloading]="loading" [scroll]="false"></app-datatable>
            </div>
            }
            @if (activeTab == ImportTab.PLANS) {
            <div>
              <app-datatable [identifier]="'import-plans-table'" [cols]="planCols" [rows]="planRows"
                [isloading]="loading" [scroll]="false"></app-datatable>
            </div>
            }
            @if (activeTab == ImportTab.EXTERNAL_VENDOR_FILES) {
            <div>
              <app-datatable [identifier]="'import-ext-files-table'" [cols]="fileTableCols" [rows]="extRows"
                [isloading]="loading" [scroll]="false"></app-datatable>
            </div>
            }
            @if (activeTab == ImportTab.PRODUCTS) {
            <div>
              <app-datatable [identifier]="'import-products-table'" [cols]="fileTableCols" [rows]="productRows"
                [isloading]="loading" [scroll]="false"></app-datatable>
            </div>
            }
          </div>
        </ng-scrollbar>
      </div>
    </form>
    <div class="ot-panel__footer ot-panel__footer--is-right-justified">
      <div class="ot-btn-group">
        <button role="button" id="import-btn" class="ot-btn ot-btn--is-primary" (click)="import()"
          [disabled]="objectForm.invalid" i18n>
          Import
        </button>
        <button role="button" id="cancel-btn" class="ot-btn ot-btn--is-secondary" (click)="closeForm(false)" i18n>
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
} @else {
<div id="import-loading" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" i18n>Importing solution, please wait...</div>
</div>
}